import { clone } from "@helpers/object.helper";
import { Actioner } from "@services/actioner";
import { reportError } from "@utils/errorReporting";

// Copied from https://github.com/BranchMetrics/react-native-branch-deep-linking-attribution/blob/master/android/src/main/java/io/branch/rnbranch/RNBranchModule.java
// export const BranchEvent = {
//   // Commerce events
//   AddToCart: "STANDARD_EVENT_ADD_TO_CART",
//   AddToWishlist: "STANDARD_EVENT_ADD_TO_WISHLIST",
//   ViewCart: "STANDARD_EVENT_VIEW_CART",
//   InitiatePurchase: "STANDARD_EVENT_INITIATE_PURCHASE",
//   AddPaymentInfo: "STANDARD_EVENT_ADD_PAYMENT_INFO",
//   Purchase: "STANDARD_EVENT_PURCHASE",
//   SpendCredits: "STANDARD_EVENT_SPEND_CREDITS",
//   ViewAd: "STANDARD_EVENT_VIEW_AD",
//   ClickAd: "STANDARD_EVENT_CLICK_AD",
//   // Content Events
//   Search: "STANDARD_EVENT_SEARCH",
//   ViewItem: "STANDARD_EVENT_VIEW_ITEM",
//   ViewItems: "STANDARD_EVENT_VIEW_ITEMS",
//   Rate: "STANDARD_EVENT_RATE",
//   Share: "STANDARD_EVENT_SHARE",
//   // User Lifecycle Events
//   CompleteRegistration: "STANDARD_EVENT_COMPLETE_REGISTRATION",
//   CompleteTutorial: "STANDARD_EVENT_COMPLETE_TUTORIAL",
//   AchieveLevel: "STANDARD_EVENT_ACHIEVE_LEVEL",
//   UnlockAchievement: "STANDARD_EVENT_UNLOCK_ACHIEVEMENT",
//   Invite: "STANDARD_EVENT_INVITE",
//   Login: "STANDARD_EVENT_LOGIN",
//   Reserve: "STANDARD_EVENT_RESERVE",
//   Subscribe: "STANDARD_EVENT_SUBSCRIBE",
//   StartTrial: "STANDARD_EVENT_START_TRIAL",
// };

const listeners = [];

export const eventKeys = [
	Actioner.keyDefs.NAVIGATE,
	Actioner.keyDefs.BUY_SET_CREDIT_CARD,
	Actioner.keyDefs.BUY_SUCCESS,
	Actioner.keyDefs.BUY_INITIATE_PURCHASE,
	Actioner.keyDefs.BUY_SET_EMAIL,
	Actioner.keyDefs.LOGIN_SUCCESS,
	Actioner.keyDefs.BUY_SET_ACCOUNT_ID,
	Actioner.keyDefs.USE_ADD_INTL_ROAMING,
	Actioner.keyDefs.USE_ADD_IDD,
	Actioner.keyDefs.ACTIVATE_SIM_CARD_NUMBER,
	Actioner.keyDefs.ACTIVATE_SUBMIT,
	Actioner.keyDefs.MESSAGE_RECEIVED,
];

const eventLogger = (event, data) => {
	console.debug("Branch", event, data);
};

const BranchAnalytics = {
	start: () => {
		if (!window || !window.branch) {
			reportError(new Error("Branch could not start due to being uninitialized"), {
				route: typeof window !== "undefined" ? window.location.pathname : undefined,
				flowStep: window?.currentBuyFlowStep,
				component: "BranchAnalytics",
				action: "start",
			});
			return;
		}

		if (process.env.NODE_ENV === "development") {
			window.branch.addListener(eventLogger);
		}

		eventKeys.forEach((eventkey) => {
			listeners.push(
				Actioner.addListener(eventkey, async (payload) => {
					try {
						const key = clone(payload.actionKey);
						const eventData = !eventkey.sensitive ? payload : {};

						switch (key.label) {
							case Actioner.keyDefs.NAVIGATE.label:
								switch (eventData.routeName) {
									case "BuyPlanSummaryPage":
										window.branch.logEvent("VIEW_ITEM");
										break;
									default:
										break;
								}
								break;
							case Actioner.keyDefs.BUY_SET_ACCOUNT_ID.label:
								window.branch.setIdentity(eventData.value.toString());
								break;
							// Commerce Events
							case Actioner.keyDefs.BUY_INITIATE_PURCHASE.label:
								window.branch.logEvent("INITIATE_PURCHASE");
								break;
							case Actioner.keyDefs.BUY_SET_CREDIT_CARD.label:
								window.branch.logEvent("ADD_PAYMENT_INFO");
								break;
							case Actioner.keyDefs.BUY_SUCCESS.label:
								window.branch.logEvent("PURCHASE");
								break;
							// Custom Commerce Events
							case Actioner.keyDefs.USE_ADD_INTL_ROAMING.label:
								window.branch.logEvent("USE_ADD_INTL_ROAMING");
								break;
							case Actioner.keyDefs.USE_ADD_IDD.label:
								window.branch.logEvent("USE_ADD_IDD");
								break;
							// Custom Life Cycle Events
							case Actioner.keyDefs.BUY_SET_EMAIL.label:
								window.branch.logEvent("SUBSCRIBE");
								break;
							case Actioner.keyDefs.LOGIN_SUCCESS.label:
								window.branch.logEvent("LOGIN");
								break;
							// Custom Events:
							case Actioner.keyDefs.ACTIVATE_SIM_CARD_NUMBER.label:
								window.branch.logEvent("ACTIVATE_SIM_CARD_NUMBER");
								break;
							case Actioner.keyDefs.ACTIVATE_SUBMIT.label:
								window.branch.logEvent("PORT_SUBMIT");
								break;
							default:
								throw new Error(`Unhandled event ${key.label}`);
						}
					} catch (e) {
						Actioner.trigger(Actioner.keyDefs.ERROR, e);
					}
				}),
			);
		});

		// TODO: make these log dev only
		if (process.env.NODE_ENV === "development") {
			console.log("Branch listener started");
		}
	},

	stop: () => {
		if (process.env.NODE_ENV === "development") {
			window.branch?.removeListener(eventLogger);
		}
		listeners.forEach((listener) => {
			listener.remove();
		});
	},
};

export default BranchAnalytics;
